import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourHomeAwayFromHome from "./sections/YourHomeAwayFromHome";
import ExploreOurPrimeStays from "./sections/ExploreOurPrimeStays";
import ThePraiseSpaceStandard from "./sections/ThePraiseSpaceStandard";
import OurSeamlessProcess from "./sections/OurSeamlessProcess";
import GuestSuccessStories from "./sections/GuestSuccessStories";
import ByTheNumbers from "./sections/ByTheNumbers";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourHomeAwayFromHome />
      <ExploreOurPrimeStays />
      <ThePraiseSpaceStandard />
      <OurSeamlessProcess />
      <GuestSuccessStories />
      <ByTheNumbers />
      <Footer />
    </div>;
}